import React from "react";
import styled from "styled-components";
import LegalCmsPage from "../../../components/legal/LegalCmsPage";

const PrivacyPolicy = () => (
  <LegalCmsPage
    kind="privacy"
    titleKey="privacy.title"
    pageClassName="privacy-policy-page"
    Wrapper={PrivacyWrapper}
  />
);

export default PrivacyPolicy;

export const PrivacyWrapper = styled.div`
  direction: ${(props) => props.dir || "ltr"};
  text-align: ${(props) => (props.dir === "rtl" ? "right" : "left")};
  padding: 0 0 20px 0;

  .legal-cms-content {
    line-height: 1.8;
    color: #555;
  }

  .legal-cms-message {
    margin: 30px 0;
    color: #798caf;
    text-align: center;
  }

  .legal-cms-html {
    h1,
    h2,
    h3,
    h4,
    h5 {
      font-size: 20px;
      margin: 30px 0 15px;
      color: #333;
      font-weight: 600;
    }

    p {
      margin-bottom: 20px;
    }

    ul,
    ol {
      margin-bottom: 20px;
      padding-inline-start: 1.25rem;
    }

    a {
      color: #007bff;
      text-decoration: underline;
    }
  }
`;
